import React from 'react';
import MainStore from '../../../MainStore';
import WorkStore from './WorkStore';

export default class WorkLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }

        this.handleWorkClick = this.handleWorkClick.bind(this);
    }

    handleWorkClick() {
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Work/GetWork?id=' + this.props.workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    WorkStore.openWorkDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        return (
            <div className="work-link" onClick={this.handleWorkClick}>{this.props.number}</div>
        );
    }
}
